import { Component, OnInit, ViewChild, EventEmitter, Renderer2 } from '@angular/core';
import { Observable, throwError, Subscription } from 'rxjs';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import { messages as i18n } from '@teem/constants/messages';


import { TeemappTableComponent } from '@teem/shared-component/teemapp-table/teemapp-table.component';
import { ACTIONS as CLIENT_ACTIONS } from '@teem/constants/client';
import { UserCurrencyPipe } from '@teem/pipes/user-currency.pipe';
import { LoaderService } from '@teem/services/loader.service';
import { ClientService } from '@teem/services/client.service';
import { MixpanelService } from '@teem/services/mixpanel.service';
import { Client } from '@teem/models/client';

import { AddClientModalComponent } from '@teem/clients-module/modals/add-client-modal/add-client-modal.component';
import { ImportClientModalComponent } from '@teem/clients-module/modals/import-client-modal/import-client-modal.component';
import * as Api from '@teem/core/constants/api';

import { client as clientApi } from '@teem/core/constants/api';
import { environment } from '@teem/environments/environment';
import { Subject } from 'rxjs/Subject';
import { queryString, uniqueId, parseDate } from '@teem/helpers/functions';
import { catchError, debounceTime } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { ACTIONS as INVOICE_ACTIONS } from '@teem/constants/invoice';
import ClientsTableSchema from '@teem/clients-module/classes/clients-table-schema';
import { InvoiceService } from '@teem/app/core/services/invoice.service';
import { Invoice } from '@teem/app/core/models/invoice';
import { UserService } from '@teem/app/core/services/user.service';
import { SharedDataService } from '@teem/app/core/services/shared-data.service';


declare var $;

@Component({
	selector: 'app-clients',
	templateUrl: './clients.component.html',
	styleUrls: ['./clients.component.scss'],
	providers: [UserCurrencyPipe]
})
export class ClientsComponent implements OnInit {
	@ViewChild('clientsTableRef') clientsTableRef: TeemappTableComponent;
	@ViewChild('searchInput') searchInput: any;

	// new code start
	viewMode: 'list' | 'card' = 'list';
	switchView(mode: 'list' | 'card') {
		this.viewMode = mode;
	}
	showOptions: boolean = false;


	activeRowId: number | null = null;

	toggleOptions(rowId: number): void {
		this.activeRowId = this.activeRowId === rowId ? null : rowId;
	}

	isMenuVisible(rowId: number): boolean {
		return this.activeRowId === rowId;
	}
	// new code end

	clientsCount: number = 0;
	clientsTable = new ClientsTableSchema(this);
	activeTab: string = "all-clients";
	isSearchEnabled: boolean = false;
	activeClient: Client = null;
	isFilter: boolean = false;
	activeInvoice: any;

	selectKey: string;
	paginator: any = {
		id: 'table-paginator',
		currentPage: 1,
		itemsPerPage: environment.pageSize,
		totalItems: 0
	}
	name: string = 'clients';
	searchSubscription: Subscription;
	search = new Subject<string>();
	searchText: string;
	showMenu: boolean = false;
	selected: Array<any> = [];
	selectedRows: Array<any> = [];
	loading: boolean = false;

	filterParams: object = {};
	itemsPerPageOptions = [10, 20, 50, 100];
	data: Array<object> = [];
	onLoad: EventEmitter<any> = new EventEmitter()
	// tableSchema: any = this.clientsTable;
	selectable: boolean = false;
	onSelect: EventEmitter<any> = new EventEmitter()
	userInfo: any;
	totalTableColumns: any = 7;
	permissions: any;
	searchTerm: string = '';


	constructor(
		private modalService: NgbModal,
		private loaderService: LoaderService,
		private clientService: ClientService,
		private mixpanelService: MixpanelService,
		private currencyPipe: UserCurrencyPipe,
		private httpClient: HttpClient,
		private router: Router,
		private renderer: Renderer2,
		private userService:UserService,
		private invoiceService: InvoiceService,
		private sharedDataService:SharedDataService,
	) { }

	ngOnInit(): void {
		this.mixpanelService.track('clients_list_view');
		// this.selectKey = this.clientsTable.keyColumn;

		this.paginator.id = `${this.name}-table-paginator-${uniqueId()}`

		this.searchSubscription = this.search.asObservable().pipe(debounceTime(300)).subscribe(data => {
			if (this.searchText != data) {
				this.searchText = data;

				if (this.searchText.length == 0 || this.searchText.length >= 3) {
					this.getPage(1, false);
				}
			}
		})

		this.getPage(1);

		this.sharedDataService.asObservable().subscribe((data) => {
            if (data) {
              if (data.userInfo) {
                this.userInfo = data.userInfo
              }
      
              if (data.permissions) {
                this.permissions = data.permissions;
              }
            }
        })

	}

	onChangeItemsPerPage(event: Event, api: any) {
		const selectElement = event.target as HTMLSelectElement;
		this.paginator.itemsPerPage = +selectElement.value;
		this.getPage(1);
		this.initNiceSelect();
	}

	initNiceSelect() {
		console.log('this is inside.')
		setTimeout(() => {
			const $select = $('#tab-links-select[nice-select]');
			$select.niceSelect?.('destroy');  // clean up
			$select.niceSelect();             // re-init
		}, 10);
	}

	reset() {
		this.selected = [];
		this.selectedRows = [];
		this.showMenu = false;
	}

	orderAction(obj: any) {
		console.log('text 1')
		switch (obj.action) {
			case "edit_invoice":
				this.onEditInvoice([obj.uuid]);
				break;
		}
	}

	onEditInvoice(selectedInvoices: Array<string>) {
		console.log('test data');
		if (selectedInvoices.length === 1) {
			this.loaderService.startLoading();
			this.invoiceService.get(selectedInvoices[0]).subscribe((invoice: Invoice) => {
				this.activeInvoice = invoice;
				this.activeTab = "edit-invoice";
				this.loaderService.stopLoading();
			}, err => {
				Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
				this.loaderService.stopLoading();
			})
		}
	}

	public getPage(page: number, loading: boolean = true, additionalParams: any = null) {
		// Unselect selected items
		this.reset();

		if (loading) {
			this.loaderService.startLoading();
			this.loading = true; // to show loading text in table
		}

		let params: any = {
			page: page,
			limit: this.paginator.itemsPerPage,
			q: this.searchTerm
		}

		if (this.searchText && this.searchText.length >= 3) {
			params.q = this.searchText;
		}

		if (additionalParams) {
			Object.assign(this.filterParams, additionalParams);
		}

		Object.assign(params, this.filterParams);

		this.getData(params).subscribe(r => {
			if (r.data)
				this.data = r.data;

			if (r.meta) {
				this.paginator.totalItems = r.meta.total;
				this.paginator.currentPage = r.meta.current_page;
				this.paginator.from = r.meta.from;
				this.paginator.to = r.meta.to;
				this.paginator.itemsPerPage = parseInt(r.meta.per_page, 10);
				this.data = r.data;

				this.onLoad.emit({
					totalItems: r.meta.total
				});
			}

			this.loaderService.stopLoading();
			this.loading = false;
			this.initNiceSelect();
		}, (err) => {
			this.loading = false;
			this.loaderService.stopLoading()
		})
	}

	toggleSelect(id: any, row: any) {
		let index = this.selected.indexOf(id);
		if (index == -1) {
			this.selected.push(id);

			this.selectedRows[row[this.selectKey]] = row;
			this.onSelect.emit(Object.values(this.selectedRows))
		}
		else {
			this.selected.splice(index, 1);

			delete this.selectedRows[row[this.selectKey]];

			this.onSelect.emit(Object.values(this.selectedRows));

			if (this.selected.length == 0) {
				this.showMenu = false;
			}
		}
	}

	getData(params): Observable<any> {
		console.log('in get-data')
		let url = `${Api.client.all}`;
		if (url.indexOf('?') == -1)
			url += ('?' + queryString(params));
		else
			url += ('&' + queryString(params));

		return this.httpClient.get(`${url}`).pipe(
			catchError((err: any) => {
				this.loaderService.stopLoading()
				return throwError(err);
			})
		)
	}

	onTableDataClick(action, client: any) {
		switch (action) {
			case CLIENT_ACTIONS.SEND_INVOICE:
				this.sendInvoice(client)
				break;
			case CLIENT_ACTIONS.EDIT:
				this.editClient(client)
				break;
		}
	}

	openAddClientModal() {
		const modalRef = this.modalService.open(AddClientModalComponent);

		// Set id on modal dialog
		modalRef.componentInstance.el.nativeElement.parentNode.parentNode.parentNode.id = "newClient";

		modalRef.result.then(result => {
			// this.clientsTableRef.getPage(1);
			this.getPage(1);
		}, fallbackResult => {
			// do nothing
		})
	}

	onLoadClients(data: any) {
		this.clientsCount = data.totalItems ? data.totalItems : 0;
		setTimeout(() => {
			$('#tab-links-select[nice-select]').niceSelect('update');
		}, 10);
	}

	onDelete(value: any) {
		this.activeTab = "all-clients";
		this.getPage(1);
	}

	toggleSearch() {
		this.isSearchEnabled = !this.isSearchEnabled;

		if (this.isSearchEnabled) {
			this.searchInput.nativeElement.focus();
		} else {
			this.searchInput.nativeElement.value = "";
			this.searchClients("");
		}
	}

	toggleFilter() {
		this.isFilter = !this.isFilter;
	}

	searchClients(term: string) {
		// alert(term);
		// this.clientsTableRef.search.next(term);
		this.searchTerm = term;

		this.getPage(1);
	}

	switchTab(tab: string) {
		this.activeTab = tab;
	}

	sendInvoice(client: any) {
		this.router.navigate(['/invoices'], { queryParams: { 'create-invoice': true, 'client': client.uuid } });
	}

	editClient(client: any, type: string = "edit") {
		// this.activeClient = client;
		this.loaderService.startLoading();
		this.clientService.get(client.uuid, { 'response-type': 'client-detail-with-project' }).subscribe(client => {
			this.activeClient = client;
			if (type == 'edit') {
				this.activeTab = "edit-client";
			} else {
				this.activeTab = "view-client";
			}			
			this.isMenuVisible(client.id)
			this.loaderService.stopLoading();
		}, err => {
			this.loaderService.stopLoading();
		})
	}

	deleteClient(clientDetail) {
		Swal.fire({
			title: i18n.are_you_sure,
			text: i18n.client.you_want_to_delete_client,
			icon: 'info',
			showCloseButton: true,
			showCancelButton: true,
			focusConfirm: false,
			confirmButtonText:
				i18n.yes,
			cancelButtonText:
				i18n.no_cancel_it
		}).then(result => {
			if (result.value) {
				this.loaderService.startLoading();
				this.clientService.delete(clientDetail.uuid).subscribe(r => {
					this.loaderService.stopLoading();

					Swal.fire(i18n.deleted, i18n.client.client_deleted, 'success');
					this.getPage(1);
				}, err => {
					this.loaderService.stopLoading();
					Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
				})
			}
		})
	}

	onSubmitEditClient(data: any) {
		this.activeTab = "all-clients";
		this.getPage(1);
	}

	exportClient() {
		const url = `${clientApi.download}`;
		window.open(url, '_blank');
		this.mixpanelService.track('client_download');
	}

	downloadPDF() {
		const url = `${clientApi.download_pdf}`;
		window.open(url, '_blank');
	}

	openImportModal() {
		const modalRef = this.modalService.open(ImportClientModalComponent);

		// Set id on modal dialog
		modalRef.componentInstance.el.nativeElement.parentNode.parentNode.parentNode.id = "newClient";

		modalRef.result.then(result => {
			this.mixpanelService.track('client_import');
			this.clientsTableRef.getPage(1);
		}, fallbackResult => {
			// do nothing
		})
	}

	toggleDropdown(event: Event): void {
		const button = event.target as HTMLElement;
		const dropdownContainer = button.closest('.custom_select');
		const dropdownMenu = dropdownContainer.querySelector('.custom_select-content');
		const allDropdowns = document.querySelectorAll('.custom_select-content');
		const allContainers = document.querySelectorAll('.custom_select');

		allDropdowns.forEach((dropdown) => {
			if (dropdown !== dropdownMenu) {
				this.renderer.setStyle(dropdown, 'display', 'none');
			}
		});

		allContainers.forEach((container) => {
			if (container !== dropdownContainer) {
				this.renderer.removeClass(container, 'active');
			}
		});

		const isDropdownVisible = dropdownMenu.getAttribute('style') === 'display: block;';

		this.renderer.setStyle(dropdownMenu, 'display', isDropdownVisible ? 'none' : 'block');

		if (isDropdownVisible) {
			this.renderer.removeClass(dropdownContainer, 'active');
		} else {
			this.renderer.addClass(dropdownContainer, 'active');
		}
	}

	onSubmitEditInvoice(data: any) {
		this.fetchPermissions();
		this.activeTab = 'edit-client';
		setTimeout(() => {
			$('#tab-links-select[nice-select]').niceSelect('update');
		}, 100);
	}

	onDeleteInvoice(invoice: Invoice) {
		this.deleteInvoices([invoice.uuid]);
	}

	fetchPermissions() {
		this.userService.getPermissions().subscribe((data: any) => {
			if (data) {
				this.sharedDataService.setItem('permissions', data);
			}
		});
	}

	deleteInvoices(selectedInvoices: Array<string>) {
		if (selectedInvoices.length) {
			Swal.fire({
				title: i18n.are_you_sure,
				text: i18n.invoice.you_want_to_delete_invoice,
				icon: 'info',
				showCloseButton: true,
				showCancelButton: true,
				focusConfirm: false,
				confirmButtonText:
					i18n.yes,
				cancelButtonText:
					i18n.no_cancel_it
			}).then(result => {
				if (result.value) {

					this.loaderService.startLoading();

					this.invoiceService.action({ 'do': INVOICE_ACTIONS.DELETE, 'ids': selectedInvoices }).subscribe(data => {
						this.loaderService.stopLoading();
						Swal.fire(i18n.deleted, selectedInvoices.length == 1 ? i18n.invoice.invoice_deleted : i18n.invoice.invoices_deleted, 'success');
						this.fetchPermissions();

					}, err => {
						this.loaderService.stopLoading();
						Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
					});
				}
			});
		}
	}
}
